<template lang="">
  <div style="padding-top: 25px;"></div>
  <section id="footer">
    <div class="containerFooter">
      <div class="text-center">
        <img src="@/assets/footerImgV2.png"/>
      </div>
      <div class="row">
        <div class="text-center text-white">
          <p>
            <strong
              ><a href="">ECOBUQ-NEOBUQ Version: ({{ getVersion() }})</a></strong
            >
          </p>
        </div>
      </div>
    </div>
  </section>
  <!-- ./Footer -->
</template>
<script>
import utils from "@/utils/configuration/config.js";

export default {
  data: () => ({
    links: ["Home", "About Us", "Contact Us"],
  }),
  methods: {
    getVersion() {
      return utils.config.app.version;
    },
  },
};
</script>
<style scoped>
/* Footer */
.containerFooter {
  bottom: 0;
  background-color: white;
}
#footer {
  border-top: 4px solid;
  border-color: midnightblue;
  position: static;
}
#footer a {
  color: midnightblue;
  text-decoration: none !important;
  background-color: transparent;
  -webkit-text-decoration-skip: objects;
}
#footer ul.social li {
  padding: 3px 0;
}
#footer ul.social li a i {
  margin-right: 5px !important;
  font-size: 25px;
  -webkit-transition: 0.5s all ease;
  -moz-transition: 0.5s all ease;
  transition: 0.5s all ease;
}
#footer ul.social li:hover a i {
  font-size: 30px;
  margin-top: -10px !important;
}
#footer ul.social li a,
#footer ul.quick-links li a {
  color: #ffffff;
}
#footer ul.social li a:hover {
  color: #eeeeee;
}
#footer ul.quick-links li {
  padding: 3px 0;
  list-style-type: none;

  -webkit-transition: 0.5s all ease;
  -moz-transition: 0.5s all ease;
  transition: 0.5s all ease;
}
#footer ul.quick-links li:hover {
  padding: 3px 0;
  margin-left: 5px !important;
  font-weight: 700;
}
#footer ul.quick-links li a i {
  margin-right: 5px !important;
}
#footer ul.quick-links li:hover a i {
  font-weight: 700;
}
.p-button-rounded {
  background-color: rgb(72, 143, 239);
  border-color: rgb(72, 143, 239);
}
</style>
